<template>
    <div class="report-info-container">
        <section class="report-info">
            <section class="image-container">
                <img
                    class="user-image"
                    :src="userImage"
                    alt="User Image"
					ref="userImage"
                >
            </section>

            <section class="user-details">
                <h4 class="user-name">
                    {{ data.name }}
                </h4>

                <span class="detail-container">
                    <span class="detail-label">
                        {{ $t('age') }}
                    </span>

                    {{ data.age | null }}
                </span>

                <span class="detail-container">
                    <span class="detail-label">
                        {{ $t('gender') }}
                    </span>

                    {{ data.gender | null }}
                </span>
            </section>            
        </section>

        <section
			class="report-average"
			:class="{
				'japanese': $i18n.locale === 'ja'
			}"
		>
            <section class="average-item">
                <div class="item-detail">
                    <h4 class="item-title">
						{{ $t('average_heart_rate') }}
                    </h4>

                    <span class="item-value">
                        {{ data.average_heartbeat }}
                    </span>
                </div>

                <img
                    :src="averageHeartRateImg()"
                    alt="Average Icon"
                    class="item-img heart"
                >
            </section>

            <section class="average-item">
                <div class="item-detail">
                    <h4 class="item-title">
						{{ averageEmotionLabel() }}
                    </h4>

                    <span class="item-value">
                        {{ data.average_emotion ? $t(String(data.average_emotion).toLowerCase()) : '-' }}
                    </span>
                </div>

                <img
                    :src="averageEmotionIcon"
                    alt="Average Icon"
                    class="item-img emotion"
                >
            </section>

            <section class="average-item">
                <div class="item-detail">
                    <h4 class="item-title">
						{{ stressCalorieLabel() }}
                    </h4>

                    <span class="item-value">
                        {{ stressCalorieValue() }}
                    </span>
                </div>

                <img
                    :src="averageStressCaloriesLevel()"
                    alt="Average Icon"
                    class="item-img stress"
					:class="{
						'calories' : ['Fitness', 'Fitness2'].includes(data.session_type)
					}"
                >
            </section>
        </section>
    </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import { mapGetters } from 'vuex'

export default {
	props: {
		data: {
			type: Object
		}
	},

	data () {
		return {
			userImageRendered: false,
			averageEmotionImgRendered: false
		}
	},

	asyncComputed: {
		userImage: {
			async get () {
				if (this.data.image) {
					this.userImageRendered = false

					// return new Promise(async (resolve, reject) => {
					// 	const response = await XMLHttpRequest(this.data.image)

					// 	const reader = new FileReader()

					// 	reader.onloadend = () => {
					// 		resolve(reader.result)

					// 		this.userImageRendered = true
					// 		this.emitRender('userimage')
					// 	}

					// 	reader.readAsDataURL(await response.blob())
					// })

					return new Promise(async (resolve) => {
						var xhr = new XMLHttpRequest()
						xhr.open('GET', this.data.image)
						xhr.responseType = 'blob'
						await xhr.send()

						xhr.onload = () => {
							var reader = new FileReader()

							reader.onloadend = () => {
								resolve(reader.result)
								this.userImageRendered = true
								this.emitRender('userimage')
							}
							reader.readAsDataURL(xhr.response)
						}
						// xhr.onerror = () => {
						// 	reject({
						// 		status: this.status,
						// 		statusText: xhr.statusText
						// 	})
						// }
					})
				}

				this.userImageRendered = true
				this.emitRender('userimage')
				return require('@/assets/img/avatar-default.png')
			},

			default: require('@/assets/img/avatar-default.png')
		},

		averageEmotionIcon: {
			async get () {
				const {
					average_emotion_filepath
				} = this.data

				this.averageEmotionImgRendered = true

				if (!average_emotion_filepath) {
					this.emitRender('averageimage')

					return require('@/assets/img/default-emoji.png')
				}

				this.averageEmotionImgRendered = false

				// return new Promise(async (resolve, reject) => {
				// 	const response = await fetch(process.env.apiUrl + average_emotion_filepath)

				// 	const reader = new FileReader()

				// 	reader.onloadend = () => {
				// 		this.averageEmotionImgRendered = true
				// 		resolve(reader.result)

				// 		this.emitRender('averageimage')
				// 	}

				// 	reader.readAsDataURL(await response.blob())
				// })

				return new Promise(async (resolve) => {
					var xhr = new XMLHttpRequest()
					xhr.open('GET', average_emotion_filepath)
					xhr.responseType = 'blob'
					await xhr.send()

					xhr.onload = () => {
						var reader = new FileReader()
						reader.onloadend = () => {
							this.averageEmotionImgRendered = true
							resolve(reader.result)
							this.emitRender('averageimage')
						}
						reader.readAsDataURL(xhr.response)
					}
					// xhr.onerror = () => {
					// 	reject({
					// 		status: this.status,
					// 		statusText: xhr.statusText
					// 	})
					// }
				})
			},

			default: require('@/assets/img/default-emoji.png')
		}
	},

	computed: {
		...mapFields('generateReport', [
			'reportData'
		]),

		...mapGetters({
			reportText: 'getReportTranslation',
			reportTextAuth: 'getAuthReportTranslation'
		})
	},

	methods: {
		averageHeartRateImg () {
			return this.data.average_heartbeat
				? require(`@/assets/img/card icons/heart_${this.data.heart_color_level.toLowerCase()}.png`)
				: require('@/assets/img/card icons/heart_low.png')
		},

		averageEmotionLabel () {
			const { session_type } = this.data

			if (session_type === 'Movie') {
				return this.$t('frequent_emotion')
			}

			return this.$t('average_emotion')
		},

		stressCalorieLabel () {
			const { session_type } = this.data

			return ['Fitness', 'Fitness2'].indexOf(session_type) > -1
				? this.$t('average_calories')
				: this.$t('average_stress_level')
		},

		averageStressCaloriesLevel () {
			const { session_type } = this.data

			if (['Fitness', 'Fitness2'].indexOf(session_type) > -1) {
				return require('@/assets/img/card icons/calories_icon.png')
			}

			return this.data.average_stress_level
				? require(`@/assets/img/card icons/stress_${this.data.heart_color_level.toLowerCase()}.png`)
				: require('@/assets/img/card icons/stress_low.png')
		},

		stressCalorieValue () {
			const {
				average_stress_level,
				average_calories,
				session_type
			} = this.data

			if (['Fitness', 'Fitness2'].indexOf(session_type) > -1) {
				return `${average_calories} Kcal`
			}
			return average_stress_level ? this.$t(String(average_stress_level).toLowerCase()) : ''
		},

		emitRender () {
            console.log(this.userImageRendered)
            console.log(this.averageEmotionImgRendered)
			if (
				this.userImageRendered &&
                this.averageEmotionImgRendered
			) {
				this.$emit('onUserInfoRender')
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.report-info-container {
    padding-bottom: 15px;

    .report-info {
        display: flex;
        margin-bottom: 15px;

        .image-container {
            width: 75px;
            height: 75px;
            border-radius: 50%;
            overflow: hidden;
            position: relative;
            margin-right: 25px;
			border: 1px solid #dadada;

            .user-image {
                height: 100%;
                min-width: 100%;
                position: absolute;
                margin-left: 50%;
                transform: translateX(-50%);
            }
        }

        .user-details {
            display: flex;
            flex-direction: column;
			flex-shrink: 0;

            .user-name {
                margin-bottom: 10px;
				flex-shrink: 0;
                text-transform: capitalize;
            }

            .detail-container {
				font-size: 13px;
				flex-shrink: 0;

                .detail-label {
                    font-weight: 600;
                    margin-right: 5px;
					font-size: 13px;
                }
            }
        }
    }

    .report-average {
        display: flex;
        justify-content: space-between;

		&.japanese {
			.item-title {
				font-size: 10px !important;
			}
		}

        .average-item {
            width: 32%;
            padding: 15px;
            display: flex;
            border: 1px solid #bbbbbb;
            justify-content: space-between;
			align-items: center;
			flex-shrink: 0;

            .item-detail {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
				font-size: 13px;
				height: 100%;
				flex-shrink: 0;
				max-width: 75%;

                .item-title {
                    font-weight: 600;
                    font-size: 13px;
                }
            }

            .item-img {
                width: 50px;
				flex-shrink: 0;

				&.emotion {
					width: 43px;
					height: 43px;
				}

				&.stress {
					width: 50px;
					height: 30px;
				}

				&.calories {
					width: 43px;
					height: 46px;
				}
            }
        }
    }
}
</style>
